import { render } from "./DirectoryOverview.vue?vue&type=template&id=d3d9c92c"
import script from "./DirectoryOverview.vue?vue&type=script&lang=js"
export * from "./DirectoryOverview.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__